/* ---------------------------------------------------------------------
 *                            SessionStorage
 * --------------------------------------------------------------------- */

/**
 * 将数据保存在会话存储中
 * @param {string} key - 数据的键
 * @param {object} value - 任何JS原生数据类型
 * @return {void}
 */
export function saveToSession(key, value) {
    sessionStorage.setItem(key, JSON.stringify(value));
}

/**
 * 从会话存储中获取数据
 * @param {string} key - 数据的键
 * @return {object} value - 任何JS原生数据类型
 */
export function getFromSession(key) {
    return JSON.parse(sessionStorage.getItem(key));
}

/**
 * 从会话存储中删除数据
 * @param {string} key - 数据的键
 * @return {void}
 */
export function removeFromSession(key) {
    return sessionStorage.removeItem(key);
}

/**
 * 清除会话存储
 * @return {void}
 */
export function clearSession() {
    return sessionStorage.clear();
}

/* ---------------------------------------------------------------------
 *                             LocalStorage
 * --------------------------------------------------------------------- */

/**
 * 将数据保存在本地存储中
 * @param {string} key - 数据的键
 * @param {object} value - 任何JS原生数据类型
 * @return {void}
 */
export function saveToStorage(key, value) {
    localStorage.setItem(key, JSON.stringify(value));
}

/**
 * 从本地存储中获取数据
 * @param {string} key - 数据的键
 * @return {object} value - 任何JS原生数据类型
 */
export function getFromStorage(key) {
    return JSON.parse(localStorage.getItem(key));
}

/**
 * 从本地存储中删除数据
 * @param {string} key - 数据的键
 * @return {void}
 */
export function removeFromStorage(key) {
    return localStorage.removeItem(key);
}

/**
 * 清除本地存储
 * @return {void}
 */
export function clearStorage() {
    return localStorage.clear();
}
